// Manual composer send-result parsing (legacy Message doc + V2 envelope).
export const PROMO_HINT_KEYS = ["pricing", "urgency"];
const KNOWN = ["sent", "failed", "unknown"];

const pickStatus = (data) => {
  if (!data || typeof data !== "object") return null;
  if (typeof data.status === "number" && data.data) return pickStatus(data.data);
  const raw = data.status ?? data.result?.status ?? data.message?.status ?? data.send_status;
  if (!raw) return null;
  const s = String(raw).toLowerCase();
  if (s === "blocked" || s === "rejected") return "failed";
  if (["delivered", "read", "accepted"].includes(s)) return "sent";
  return KNOWN.includes(s) ? s : "unknown";
};

const pickReason = (data) =>
  data?.failure_reason || data?.reason || data?.result?.reason || data?.message?.failure_reason ||
  data?.error?.title || data?.error?.message || data?.detail?.message || (typeof data?.detail === "string" ? data.detail : null) ||
  (typeof data?.error === "string" ? data.error : null);

const end = (t) => (/[.!?]$/.test(t) ? t : `${t}.`);

export function interpretSendResponse(data) {
  if (typeof data?.status === "number" && data.data) return interpretSendResponse(data.data);
  const status = pickStatus(data);
  const reason = pickReason(data);
  if (status === "sent") return { status, tone: "success", text: "Accepted by provider. Delivery ticks will update in the thread." };
  if (status === "failed") {
    return { status, tone: "error", text: `${reason ? end(`Not sent: ${reason}`) : "Not sent."} Your draft is kept.` };
  }
  return {
    status: "unknown", tone: "warning",
    text: "Delivery status is uncertain. Check the thread before resending. It will not be retried automatically. Your draft is kept.",
  };
}

export function describeSendError(err) {
  const code = err?.response?.status;
  const detail = pickReason(err?.response?.data || {});
  if (!err?.response) return "Network error. The message may or may not have been sent. Check the thread before resending. Your draft is kept.";
  if (code === 401) return "Your session has expired. Please sign in again. Your draft was not sent.";
  if (code === 409) return `${end(`Not sent: ${detail || "this message conflicts with the user's current state (DND, opt-out or offer safeguard)"}`)} Your draft is kept.`;
  if (code >= 500) return `${detail ? end(detail) + " " : ""}Delivery is not confirmed. Check the thread before resending. No automatic retry. Your draft is kept.`;
  if (code === 403) return "You don't have permission to send messages. Your draft is kept.";
  return `${end(`Send failed${detail ? `: ${detail}` : ""}`)} Your draft is kept.`;
}
